import React from 'react';
import { connect } from 'react-redux';
import Hero from 'page/hero/Hero';
import SearchContainer from 'search/SearchContainer';
import ScheduleModuleContainer from 'scheduleModule/ScheduleModuleContainer';
import playable from 'common/playable';
import heroSelector from 'selectors/heroSelector';
import { showSearchByCountrySelector } from 'selectors/pageSelector';
import { isEmpty } from 'lib/util';
import { PlayerPlacement } from 'enums';

const PlayableHero = playable(Hero);
const ENABLE_SEARCH = false;

const TopLayoutContainer = (props) => {
    let hero = null;
    let search = null;
    let scheduleModule = null;

    if (!isEmpty(props.hero)) {
        hero = (
            <PlayableHero
                content={props.hero}
                playerPlacement={PlayerPlacement.HERO}
                placement="inline-hero"
                isHero
            />
        );
        search = <SearchContainer enabled={props.showSearch} />;
        scheduleModule = <ScheduleModuleContainer />;
    }
    const colCClassName = props.showSearch ? 'col-c' : 'col-c no-search';
    return (
        <div className="layout-bc">
            <section className="col-b">
                {hero}
            </section>
            <section className={colCClassName}>
                {search}
                {scheduleModule}
            </section>
        </div>
    );
};

TopLayoutContainer.propTypes = {
    hero: React.PropTypes.object,
    showSearch: React.PropTypes.bool
};

const mapStateToProps = (state) => ({
    hero: heroSelector(state),
    showSearch: ENABLE_SEARCH && showSearchByCountrySelector(state)
});

export default connect(mapStateToProps)(TopLayoutContainer);
export { TopLayoutContainer as BaseTopLayoutContainer };



// WEBPACK FOOTER //
// ./app/page/common/TopLayoutContainer.js